
import {
  Component, Vue,
} from 'nuxt-property-decorator'
import GptLog from './GptLog.vue'
import GptWelcome from './GptWelcome.vue'
import BaseIconButton from '../base/BaseIconButton.vue'
import { globalLabelAsString } from '../../shared/general/services/StoreService'
import type { TGptLog, TGptMessage, TGptChatResponse } from '../../shared/general/types/GptHub'

@Component({
  name: 'GptHubIntegration',
  components: {
    GptLog,
    GptWelcome,
    BaseIconButton,
  },
})
export default class GptHubIntegration extends Vue {
  private log : TGptMessage[] = [
    {
      role: 'developer',
      content: 'You must deliver all responses and output as plain text without any Markdown or formatting.'
        + ' Do not use asterisks or stars for formatting. There are no exceptions!',
    },
  ]

  private input : string = ''

  private loading : boolean = false

  private failed : boolean = false

  private get gptHubInputLabel () : string {
    return globalLabelAsString('gpt_hub_input_label')
  }

  private get gptHubHintLabel () : string {
    return globalLabelAsString('gpt_hub_hint_label')
  }

  private get filteredLog () : TGptMessage[] {
    return this.log.filter((entry) => entry.role !== 'developer')
  }

  private async send () : Promise<void> {
    if (!this.input) return

    const message : TGptMessage = { role: 'user', content: this.input }

    this.log = [...this.log, message]
    this.input = ''

    await this.callGptHub()
  }

  private async resend () : Promise<void> {
    await this.callGptHub()
  }

  private async callGptHub () : Promise<void> {
    try {
      this.loading = true
      this.failed = false

      const body : TGptLog = { messages: this.log }
      const response = await fetch('/api/gptHub/chat', { method: 'POST', body: JSON.stringify(body) })
      const data : TGptChatResponse = await response.json()

      if (data?.content) {
        this.log = [...this.log, { role: 'assistant', content: data.content }]
      } else {
        this.failed = true
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error)
      this.failed = true
    } finally {
      this.loading = false
    }
  }
}
